<template>
  <formulate-adapter :view-only="viewOnly" :debug="debug" ref="adapter" v-model="formdata" :form-definition="formDefinition"/>
</template>

<script>

import FormulateAdapter from './adapters/Formulate/FormulateAdapter.vue'

export default {

  components: {
    FormulateAdapter
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    formDefinition: {
      type: Object,
      default: () => ({})
    },
    debug: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    formdata: {}
  }),

  mounted() {
    this.formdata = this.value
    this.$emit('mounted', this)
  },

  methods: {
    formRef() {
      return this._.get(this, '$refs.adapter.$refs.form')
    },
    validate() {
      if (this.formRef()) {
        // Vue Formulate Specific
        this.formRef().showErrors()
      }
    },
    hasErrors() {
      if (this.formRef()) {
        return this.formRef().hasErrors
      } else return false
    }
  },

  watch: {
    value(val) {
      this.formdata = val
    },
    formdata(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style>

</style>